import { __ } from '@wordpress/i18n';

const MissingOrEmptyPageTitle = window.edac_frontend_fixes?.missing_or_empty_page_title || {
	enabled: false,
};

const MissingOrEmptyPageTitleFix = () => {
	if ( ! MissingOrEmptyPageTitle.enabled ) {
		return;
	}

	if (
		( document?.title !== null && document?.title !== 'undefined' ) &&
		document?.title.trim() !== ''
	) {
		return;
	}

	// If there's a post title on the script data use it.
	if ( MissingOrEmptyPageTitle?.post_title && MissingOrEmptyPageTitle.post_title.trim() !== '' ) {
		document.title = __( MissingOrEmptyPageTitle.post_title, 'accessibility-checker-pro' );
		return;
	}

	// Try finding the first header element with text content and use it.
	const headers = document.querySelectorAll( 'h1, .h1, h2, h3, h4, h5, h6' );
	for ( let i = 0; i < headers.length; i++ ) {
		const header = headers[ i ];
		if ( header.innerText.trim() !== '' ) {
			document.title = __( header.innerText, 'accessibility-checker-pro' );
			if (
				( MissingOrEmptyPageTitle.site_name && MissingOrEmptyPageTitle.site_name.trim() !== '' ) &&
				( MissingOrEmptyPageTitle.site_name.trim() !== document.title.trim() )
			) {
				document.title += ' ' + ( MissingOrEmptyPageTitle.title_separator ? __( MissingOrEmptyPageTitle.title_separator, 'accessibility-checker-pro' ) : '-' ) + ' ' + __( MissingOrEmptyPageTitle.site_name, 'accessibility-checker-pro' );
			}
			break;
		}
	}

	// Fallback to the site title as a last resort.
	if ( ! document.title && ( MissingOrEmptyPageTitle.site_name && MissingOrEmptyPageTitle.site_name.trim() !== '' ) ) {
		document.title = __( MissingOrEmptyPageTitle.site_name, 'accessibility-checker-pro' );
	}
};

export default MissingOrEmptyPageTitleFix;
